import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Auth from 'src/api/auth';
import { useParams } from 'react-router';
import toast from 'react-hot-toast';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ResetView = () => {
  const classes = useStyles();
  const { id } = useParams();

  const submit = async ({ password }) => {
    try {
      await Auth.resetPassword({ password, token: id });
      toast.success('Reset Successful!');
      window.location.replace('/login');
    } catch (error) {
      const errors = error?.response?.data?.errors;
      toast.error(
        (Array.isArray(errors) && (errors[0]?.message || errors[0])) ||
          'Reset password cannot be completed!'
      );
    }
  };

  return (
    <Page className={classes.root} title="Reset password">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              password: '',
              confirmPassword: ''
            }}
            validationSchema={Yup.object().shape({
              // Mirrors the API's strongPassword rule.
              password: Yup.string()
                .min(8, 'Password must be at least 8 characters')
                .max(128)
                .matches(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).+$/,
                  'Use upper and lower case letters, a number and one of @$!%*?&'
                )
                .required('Password is required'),
              confirmPassword: Yup.string().oneOf(
                [Yup.ref('password'), null],
                'Passwords must match'
              )
            })}
            onSubmit={submit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography color="textPrimary" variant="h2">
                    Password Reset
                  </Typography>
                </Box>

                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(
                    touched.confirmPassword && errors.confirmPassword
                  )}
                  fullWidth
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  label="Confirm password"
                  margin="normal"
                  name="confirmPassword"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.confirmPassword}
                  variant="outlined"
                />
                <Box my={2}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Reset now
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

ResetView.propTypes = {};

export default ResetView;
